import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {
  Alert, Collapse, IconButton,
} from '@mui/material';

interface CollapsableNotificationProps {
  message?: string,
  type?: 'error' | 'success'
  open: boolean,
  close: () => void
}

const CollapsableNotification = ({ type = 'error',
  message = 'An error occurred',
  open = false, close }: CollapsableNotificationProps) =>
  (
    <Collapse in={open}>
      <Alert
        severity={type}
        action={(
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={close}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        )}
      >
        {message}
      </Alert>
    </Collapse>
  );

export default CollapsableNotification;
